import Button from '@mui/material/Button';

export const UserInfo = () => {

  return (
    <div>
      <Button href="/myaccount">PERFIL USUARIO</Button>
      
    </div>
    
  ) 
  
  
};

